import { ITheme, mediaQuery } from '@quicktools/shared-components/styles';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    pills: {
      display: 'block',
      [mediaQuery(breakpoints.laptop)]: {
        display: 'none',
      },
    },
    dropdown: {
      display: 'none',
      [mediaQuery(breakpoints.laptop)]: {
        display: 'block',
      },
    },
  }),
  {
    name: 'generic-pills-dropdown',
  },
);
export default useStyles;
